import { render, staticRenderFns } from "./ScadaMeasurements.vue?vue&type=template&id=56e5df85&scoped=true&"
import script from "./ScadaMeasurements.vue?vue&type=script&lang=js&"
export * from "./ScadaMeasurements.vue?vue&type=script&lang=js&"
import style0 from "./ScadaMeasurements.vue?vue&type=style&index=0&id=56e5df85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e5df85",
  null
  
)

export default component.exports